import React, { useState, useEffect } from 'react';
import {
	getSingleLotHistory,
	getMultipleLotsHistory,
	getSingleLotStatusHistory,
} from '../../../api/Siteplan/getHistory.api';
import { Stepper, Step, StepLabel, StepContent } from '@material-ui/core';
import { numberWithCommas } from '../../../utils/numberWithCommas';
import styles from './LotHistory.module.scss';
import dayjs from 'dayjs';

const stepIcon = (status) => {
	if (status === 'Cancelled') {
		return <div className={styles.circle_cancelled} />;
	}
	if (status === 'Sold') {
		return <div className={styles.circle_sold} />;
	}
	if (status === 'Pending') {
		return <div className={styles.circle_pending} />;
	}
	return <div className={styles.circle} />;
};

const LotHistory = (props) => {
	const [lotHistory, setLotHistory] = useState([]);
	const [lotStatusHistory, setLotStatusHistory] = useState([]);
	const [lotAllHistory, setLotAllHistory] = useState([]);
	const { lotId, lotIdArr, lotPrice } = props;

	useEffect(() => {
		if (lotId) {
			getSingleLotHistory(lotId, (returned) => {
				setLotHistory(returned);
			});
			getSingleLotStatusHistory(lotId, (returned) => {
				setLotStatusHistory(returned);
			});
		} else {
			getMultipleLotsHistory(lotIdArr, (returned) => {
				setLotHistory(returned);
			});
			setLotStatusHistory([]);
		}
	}, [lotId, lotIdArr]);

	useEffect(() => {
		let history = lotHistory
			.concat(lotStatusHistory)
			.sort((a, b) => b.timestamp - a.timestamp);
		setLotAllHistory(history);
	}, [lotHistory, lotStatusHistory]);

	const getPriceChange = (newValue, oldValue) => {
		let diff = Number(newValue) - Number(oldValue);
		diff = +(Math.round(diff + 'e+2') + 'e-2');
		if (diff > 0) {
			return `Increased by \$${numberWithCommas(Math.abs(diff))}`;
		} else {
			return `Decreased by \$${numberWithCommas(Math.abs(diff))}`;
		}
	};
	return (
		<div className={styles.lot_history}>
			<h2 className={styles.lot_history_title}>Lot History</h2>
			<Stepper
				activeStep={-1}
				orientation='vertical'
				className={styles.stepper}
			>
				{/* {lotHistory.map((item, index) => (
					<Step key={index}>
						<StepLabel StepIconComponent={stepIcon}>
							<div>
								<span className={styles.lot_id}>
									{'Lot ' + item.lotId + ' | '}
								</span>
								<span className={styles.price}>
									{'$' + item.newValue}
								</span>
							</div>
							<div className={styles.price_change}>
								{getPriceChange(item.newValue, item.oldValue)}
							</div>
							<div className={styles.time}>
								{dayjs(item.timestamp).format('ddd DD MMM')} |
								By {item.alteredByName}
							</div>
						</StepLabel>
					</Step>
				))} */}
				{lotAllHistory.map((item, index) => (
					<Step key={index}>
						{item.status ? (
							<>
								<StepLabel
									StepIconComponent={() =>
										stepIcon(item.status)
									}
								>
									<div>
										<span className={styles.lot_id}>
											{'Lot ' + item.lotId + ' | '}
										</span>
										<span className={styles.price}>
											{'$' + numberWithCommas(item.price)}
										</span>
									</div>
									<div className={styles.status}>
										{item.status + ': ' + item.clientName}
									</div>
									<div className={styles.time}>
										{dayjs(item.timestamp).format(
											'ddd DD MMM'
										)}{' '}
										| By {item.salesAgentName}
									</div>
								</StepLabel>
							</>
						) : (
							<>
								<StepLabel StepIconComponent={() => stepIcon()}>
									<div>
										<span className={styles.lot_id}>
											{'Lot ' + item.lotId + ' | '}
										</span>
										<span className={styles.price}>
											{'$' +
												numberWithCommas(
													item?.newValue
												)}
										</span>
									</div>
									<div className={styles.price_change}>
										{getPriceChange(
											item.newValue,
											item.oldValue
										)}
									</div>
									<div className={styles.time}>
										{dayjs(item.timestamp).format(
											'ddd DD MMM'
										)}{' '}
										| By {item.alteredByName}
									</div>
								</StepLabel>
							</>
						)}
					</Step>
				))}
				{lotAllHistory &&
					lotAllHistory.length === 0 &&
					lotId !== undefined && (
						<Step>
							<StepLabel StepIconComponent={() => stepIcon()}>
								<div>
									<span className={styles.lot_id}>
										{'Lot ' + lotId + ' | '}
									</span>
									<span className={styles.price}>
										{'$' + numberWithCommas(lotPrice)}
									</span>
								</div>
							</StepLabel>
						</Step>
					)}
			</Stepper>
		</div>
	);
};

export default LotHistory;
